module.exports = __webpack_public_path__ + "static/img/ruzhu_exam_list.bd5b2828.png";